import * as React from "react";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";

import useActiveFilters from "../../../hooks/useActiveFilters";
import ParkingSpotsTable from "../../../components/Tables/Parking/ParkingSpots/FullTable";

import { buildQueryString } from "../../../store/base";

export default function ParkingSpots() {
  const { filteredRealEstates } = useActiveFilters();

  const persistantQuery = {
    realestate_ids: filteredRealEstates,
  };

  return (
    <DetailInnerWrapper>
      <DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>Fordonsplatser</OverviewTitle>
        </OverviewTitleWrapper>

        <ParkingSpotsTable
          persistantQuery={persistantQuery}
          withCosts={true}
          onlyWithCosts={true}
        />
      </DetailPageBox>
    </DetailInnerWrapper>
  );
}
